import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Globe, MessageSquare, Pencil, ExternalLink, Loader2 } from "lucide-react";
import { ViewOnlyBanner } from "./ViewOnlyBanner";

export const SiteSettingsTab = ({
  darkMode, siteSettings, setSiteSettings, saveSiteSettings,
  saving, editingPage, setEditingPage, viewOnly
}) => {
  const cardBg = darkMode ? "bg-gray-800/80 border border-gray-700/50" : "";

  return (
    <>
      {viewOnly && <ViewOnlyBanner darkMode={darkMode} />}
      <Card className={`border-0 shadow-soft rounded-3xl ${cardBg}`}>
        <CardHeader>
          <CardTitle className={`flex items-center gap-2 ${darkMode ? "text-gray-100" : ""}`}><Globe className="w-5 h-5" /> Social Media Links</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          {[
            { key: "facebook", label: "Facebook URL", placeholder: "https://facebook.com/yourpage" },
            { key: "tiktok", label: "TikTok URL", placeholder: "https://tiktok.com/@yourprofile" },
            { key: "instagram", label: "Instagram URL", placeholder: "https://instagram.com/yourprofile" },
            { key: "whatsapp", label: "WhatsApp Link", placeholder: "https://wa.me/233XXXXXXXXX" },
          ].map(({ key, label, placeholder }) => (
            <div key={key} className="space-y-1">
              <Label className={darkMode ? "text-gray-300" : ""}>{label}</Label>
              <Input
                value={siteSettings.social_links?.[key] || ""}
                onChange={e => setSiteSettings(prev => ({ ...prev, social_links: { ...prev.social_links, [key]: e.target.value } }))}
                placeholder={placeholder}
                className={`rounded-xl ${darkMode ? "bg-gray-700 border-gray-600 text-gray-200 placeholder:text-gray-500" : ""}`}
                data-testid={`settings-social-${key}`}
                disabled={viewOnly}
              />
            </div>
          ))}
          {!viewOnly && (
          <Button onClick={saveSiteSettings} disabled={saving} className="rounded-xl mt-4" data-testid="save-social-links">
            {saving ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null} Save Social Links
          </Button>
          )}
        </CardContent>
      </Card>

      <Card className={`border-0 shadow-soft rounded-3xl mt-6 ${cardBg}`}>
        <CardHeader>
          <CardTitle className={`flex items-center gap-2 ${darkMode ? "text-gray-100" : ""}`}><MessageSquare className="w-5 h-5" /> Support Pages</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {[
              { key: "about_us", label: "About Us" },
              { key: "help_center", label: "Help Center" },
              { key: "contact_us", label: "Contact Us" },
              { key: "refund_policy", label: "Refund Policy" },
            ].map(({ key, label }) => (
              <div key={key} className={`flex items-center justify-between rounded-xl p-4 ${darkMode ? "bg-gray-700/50" : "bg-gray-50"}`}>
                <div>
                  <p className={`font-medium ${darkMode ? "text-gray-200" : ""}`}>{label}</p>
                  <p className={`text-sm ${darkMode ? "text-gray-500" : "text-gray-500"}`}>{(siteSettings.pages?.[key]?.content || "").slice(0, 80)}...</p>
                </div>
                <div className="flex gap-2">
                  {!viewOnly && (
                  <Button variant="outline" size="sm" className={`rounded-xl ${darkMode ? "bg-gray-600 border-gray-500 text-gray-200 hover:bg-gray-500" : ""}`} onClick={() => setEditingPage(key)} data-testid={`edit-page-${key}`}>
                    <Pencil className="w-3.5 h-3.5 mr-1" /> Edit
                  </Button>
                  )}
                  <Button variant="outline" size="sm" className={`rounded-xl ${darkMode ? "bg-gray-600 border-gray-500 text-gray-200 hover:bg-gray-500" : ""}`} onClick={() => window.open(`/support/${key}`, "_blank")} data-testid={`view-page-${key}`}>
                    <ExternalLink className="w-3.5 h-3.5" />
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </>
  );
};
